export default "__VITE_ASSET__WE4CsP24__"